var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNatural(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5460_2537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6964 7.18786C14.3591 6.17377 15.876 6.35672 16.0512 6.33511C16.2577 4.96566 15.8337 3.54909 14.7972 2.51273L12.4904 0.205875C12.216 -0.0685781 11.7706 -0.0686719 11.4961 0.205875L9.18922 2.51273C8.15272 3.54923 7.72887 4.96608 7.93531 6.33511C8.10003 6.35541 9.6387 6.18066 11.2901 7.18786V5.62491C11.2901 5.23659 11.6049 4.92178 11.9932 4.92178C12.3815 4.92178 12.6964 5.23659 12.6964 5.62491V7.18786Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9807 7.74121C4.59258 7.74121 4.27758 8.05621 4.27758 8.44434C4.34929 11.2808 4.0889 12.0854 4.5907 13.3475H8.88914L7.28414 11.7425C7.00992 11.4678 7.00992 11.0225 7.28414 10.7478C7.55883 10.4731 8.00414 10.4731 8.27883 10.7478L10.878 13.3475H11.2901V8.94965C10.4927 8.20059 9.4207 7.74121 8.2432 7.74121H4.9807Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6963 8.94965V13.3475H13.1083L15.7075 10.7478C15.9822 10.4731 16.4275 10.4731 16.7022 10.7478C16.9764 11.0225 16.9764 11.4678 16.7022 11.7425L15.0972 13.3475H19.3957C19.8967 12.0873 19.6368 11.2907 19.7088 8.44434C19.7088 8.05621 19.3938 7.74121 19.0057 7.74121H15.7432C14.5657 7.74121 13.4936 8.20059 12.6963 8.94965Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00463867 19.377C0.00463867 21.9262 2.07853 24 4.62769 24H11.2735V14.7539H4.62769C2.07853 14.7539 0.00463867 16.8278 0.00463867 19.377Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3726 14.7539H12.6799V24H19.3726C21.9217 24 23.9956 21.9262 23.9956 19.377C23.9956 16.8278 21.9217 14.7539 19.3726 14.7539Z",
    fill: "#C59C37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5460_2537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatural);
export default __webpack_public_path__ + "static/media/natural.3b12165a5fea0e559df57b28e97ca3c0.svg";
export { ForwardRef as ReactComponent };